<header class="new-header">
  <div class="new-header-decor" aria-hidden="true">
    <img class="new-header-decor-item new-header-decor-dot-a" src="assets/images/icones/circulo-amarelo.svg" alt="" />
    <img class="new-header-decor-item new-header-decor-dot-b" src="assets/images/icones/circulo-verde.svg" alt="" />
    <img class="new-header-decor-item new-header-decor-dot-c" src="assets/images/icones/circulo-amarelo.svg" alt="" />
    <img class="new-header-decor-item new-header-decor-tri-a" src="assets/images/icones/triangulo-vermelho.svg"
      alt="" />
    <img class="new-header-decor-item new-header-decor-tri-b" src="assets/images/icones/triangulo-azul.svg" alt="" />
  </div>

  <nav class="navbar navbar-expand-lg new-header-nav" aria-label="Menu principal">
    <div class="container-fluid new-header-inner">

      <a class="navbar-brand new-header-brand" routerLink="/" (click)="fecharMenu()"
        [attr.aria-label]="nome() ? null : 'Página inicial'">
        @if (brasaoUrl(); as brasao) {
        <img class="new-header-brasao" [src]="brasao" [alt]="altBrasao()"
          (error)="brasaoIndisponivel.set(true)" />
        }
        @if (nome(); as nomeOrgao) {
        <span class="new-header-brand-text" [class.new-header-brand-text-longo]="!!nomeCurto()">{{ nomeOrgao }}</span>
        }
        @if (nomeCurto(); as curto) {
        <span class="new-header-brand-text new-header-brand-text-curto">{{ curto }}</span>
        }
      </a>

      <!-- Botão hambúrguer (mobile) -->
      <button type="button" class="navbar-toggler new-header-toggler" (click)="toggleMenu()"
        [attr.aria-expanded]="menuAberto()" aria-controls="new-header-collapse" aria-label="Alternar menu de navegação">
        <i-lucide [name]="menuAberto() ? 'x' : 'menu'" size="26"></i-lucide>
      </button>
      <!---->

      <div id="new-header-collapse" class="collapse navbar-collapse new-header-collapse" [class.show]="menuAberto()">

        <ul class="navbar-nav new-header-menu">
          @for (item of menuItens(); track item.chave) {
          <li class="nav-item new-header-item" [class.new-header-item-dropdown]="!!item.filhos">

            @if (item.filhos; as filhos) {
            <button type="button" class="new-header-link new-header-link-toggle"
              [class.new-header-link-ativo]="dropdownAberto() === item.chave" (click)="toggleDropdown(item.chave, $event)"
              [attr.aria-expanded]="dropdownAberto() === item.chave" aria-haspopup="true">
              <span class="new-header-label">{{ item.label }}</span>
              <i-lucide class="new-header-chevron" [class.new-header-chevron-aberto]="dropdownAberto() === item.chave"
                name="chevron-down" size="16"></i-lucide>
              <img class="new-header-underline" [src]="item.linha" alt="" aria-hidden="true" />
            </button>

            <ul class="new-header-submenu" [class.new-header-submenu-aberto]="dropdownAberto() === item.chave">
              @for (filho of filhos; track $index) {
              <li>
                @if (filho.destino; as destino) {
                <a class="new-header-submenu-link" [routerLink]="destino" (click)="fecharMenu()">
                  {{ filho.label }}
                </a>
                } @else if (filho.novaAba) {
                <a class="new-header-submenu-link" [href]="filho.href" target="_blank" rel="noopener noreferrer"
                  [attr.aria-label]="filho.label + ' (abre em nova aba)'" (click)="fecharMenu()">
                  {{ filho.label }}
                </a>
                } @else {
                <a class="new-header-submenu-link" [href]="filho.href" (click)="fecharMenu()">
                  {{ filho.label }}
                </a>
                }
              </li>
              }
            </ul>

            } @else if (item.destino; as destino) {
            <a class="new-header-link" [routerLink]="destino" routerLinkActive="new-header-link-ativo"
              [routerLinkActiveOptions]="{ exact: item.exato }" (click)="fecharMenu()">
              <span class="new-header-label">{{ item.label }}</span>
              <img class="new-header-underline" [src]="item.linha" alt="" aria-hidden="true" />
            </a>
            } @else if (item.novaAba) {
            <a class="new-header-link" [href]="item.href" target="_blank" rel="noopener noreferrer"
              [attr.aria-label]="item.label + ' (abre em nova aba)'" (click)="fecharMenu()">
              <span class="new-header-label">{{ item.label }}</span>
              <img class="new-header-underline" [src]="item.linha" alt="" aria-hidden="true" />
            </a>
            } @else {
            <a class="new-header-link" [href]="item.href" (click)="fecharMenu()">
              <span class="new-header-label">{{ item.label }}</span>
              <img class="new-header-underline" [src]="item.linha" alt="" aria-hidden="true" />
            </a>
            }

          </li>
          }
        </ul>

        <div class="new-header-actions">
          @if (autenticado()) {

          <div class="new-header-conta">
            <button type="button" class="new-header-btn new-header-btn-login new-header-conta-toggle"
              (click)="toggleConta($event)" [attr.aria-expanded]="contaAberta()" aria-haspopup="true"
              aria-controls="new-header-conta-menu">
              <i-lucide name="circle-user-round" size="18"></i-lucide>
              <span>Área do cidadão</span>
              <i-lucide class="new-header-chevron" [class.new-header-chevron-aberto]="contaAberta()" name="chevron-down"
                size="16"></i-lucide>
            </button>

            <ul id="new-header-conta-menu" class="new-header-submenu new-header-conta-menu"
              [class.new-header-submenu-aberto]="contaAberta()">
              @for (atalho of atalhosAreaCidadao; track atalho.aba) {
              <li>
                <a class="new-header-submenu-link new-header-conta-link" routerLink="/area-cidadao"
                  [queryParams]="{ aba: atalho.aba }" (click)="fecharMenu()">
                  <i-lucide [name]="atalho.icone" size="16" aria-hidden="true"></i-lucide>
                  <span>{{ atalho.label }}</span>
                </a>
              </li>
              }
              <li class="new-header-conta-separador"></li>
              <li>
                <button type="button" class="new-header-submenu-link new-header-conta-link new-header-conta-sair"
                  (click)="sair()">
                  <i-lucide name="log-out" size="16" aria-hidden="true"></i-lucide>
                  <span>Sair</span>
                </button>
              </li>
            </ul>
          </div>

          } @else {

          <button type="button" class="new-header-btn new-header-btn-login" (click)="logar()">
            <i-lucide name="log-in" size="18"></i-lucide>
            <span>Logar</span>
          </button>
          <button type="button" class="new-header-btn new-header-btn-cadastro" (click)="cadastrar()">
            <i-lucide name="user-plus" size="18"></i-lucide>
            <span>Cadastro</span>
          </button>

          }
        </div>

      </div>
    </div>
  </nav>
</header>